import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ShowinDirective } from '../../../directives/animations/showin.directive';
import { CommonApiService } from '../../../services/apis/common-api-service';
import { MessageService } from '../../../services/message.service';
import { isValidEmail } from '../../../utils/utils';

@Component({
  selector: 'section[app-home-newsletter-signup]',
  imports: [NgOptimizedImage, MatButtonModule, FormsModule, ReactiveFormsModule, MatSnackBarModule, ShowinDirective],
  templateUrl: './home-newsletter-signup.html',
  styleUrl: './home-newsletter-signup.scss',
})
export class HomeNewsletterSignup {
  email: string = '';
  constructor(private messageService: MessageService, private commonApi: CommonApiService) { }

  async join() {
    this.email = this.email.trim();
    if (!this.email || !isValidEmail(this.email)) {
      this.messageService.open('Please input a valid email address!', 'OK');
      return;
    }

    try {
      await this.commonApi.joinEmailList({ email: this.email });
      this.messageService.open('Thanks for joining!');
    } catch (error) {

    }

  }
}
